import { Component, Input } from "@angular/core";
import { IndexSection } from "../store/product-index/state";
import { Environment } from "./environment";
import { trackIndexSection } from "../utils/utils";
import { createDivision } from "../data/model-utils";

@Component({
    selector: "[picker-section], [picker-product], picker-section",
    templateUrl: "picker-section.component.html",
    styleUrls: ["picker-section.component.css"],
})
export class PickerSectionComponent {
    @Input() env: Environment;
    @Input() section: IndexSection;
    @Input() root = true;

    trackSection = trackIndexSection;

    createDivision() {
        const counters = {};
        this.env.protocol.Offers.forEach((offer) => {
            offer.Divisions.forEach((division) => {
                const key = division.Label.split(/\s+\d+$/)[0];
                counters[key] = counters[key] ? counters[key] + 1 : 1;
            });
        });
        let index = counters[this.section.name.displayName];
        index = index ? index + 1 : 1;

        const newDivision = createDivision(
            this.section.application,
            "",
            this.section.category.key,
            this.section.category.printName,
            this.section.line.key,
            this.section.line.displayName,
            this.section.name.key,
            this.section.name.displayName,
            this.section.name.printName,
            index,
        );
        this.env.persistence.addManualDivision(
            this.env.customOffer,
            newDivision,
        );
    }

    get type(): SectionType {
        return this.getSectionType(this.section);
    }

    get groupedSubsections(): GroupedSections {
        const subsections = (this.section.items || []).filter(
            (section) => !section.visibility || section.visibility(this.env.cp),
        );
        return {
            iconSections: subsections.filter((section) =>
                this.filterIconSections(section),
            ),
            regularSections: subsections.filter(
                (section) => !this.filterIconSections(section),
            ),
        };
    }

    getSectionType(section: IndexSection): SectionType {
        if (section.name.icon) return "icon";
        return section.items.length === 0 ? "product" : "section";
    }

    filterIconSections(section) {
        return this.getSectionType(section) === "icon";
    }
}

interface GroupedSections {
    iconSections: IndexSection[];
    regularSections: IndexSection[];
}

type SectionType = "section" | "product" | "icon";
